import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';

import styled from 'styled-components';
import { FlexView, Row, Button, Separator } from '@cuemath/comps';

import {
  getAll as getStudentList,
  invalidateList as invalidateStudentList,
} from 'actions/student-list';
import { get as getConfig } from 'actions/configs';
import { getAll as getPrograms } from 'actions/programs';
import { openModal, closeModal } from 'actions/modal';
import { patch as editStudent } from 'actions/students';

import StudentList from './list';
import Pagination from 'modules/list/pagination';
import Search from 'modules/list/search-bar';

import { RESULTS_PER_PAGE } from 'constants/list';
import {
  FORM_ACTIONS,
  MODAL_FORM,
  MODAL_CONFIRMATION_ACTIONS,
  STUDENT_TYPE,
} from 'constants/form';
import { USER_CONFIG, BATCHES_CONFIG } from 'constants/api';
import MODAL from 'constants/modal';
import { SelectInput } from 'modules/form/index';
import { getOptions } from 'modules/form';

const FullFlexView = styled(FlexView)`
  width: 100%;
`;

const Head = styled(Row)`
  width: 100%;
  padding-left: 15px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const FilterWrapper = styled(Row)`
  width: 100%;
  padding-left: 15px;
  align-items: center;
`;

const Field = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

const Label = styled.label`
  min-width: 40%;
  padding-left: 4px;
  font-weight: 600;
`;

class TrainingAccounts extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      searchKey: null,
      listData: null,
      studentId: null,
      studentPatch: store.patch(),
      archiveStudent: false,
      filterParam: null,
      regionFilter: null,
    };
  }

  static getDerivedStateFromProps(
    { studentList, students, actions },
    { page, studentPatch, archiveStudent, studentId },
  ) {
    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const newState = {};
    const newStudentPatch = store.patch(students, studentPatch.id + studentId);

    if (newStudentPatch.resolved && archiveStudent) {
      if (newStudentPatch.resolved.isPatched) {
        actions.invalidateStudentList();
      } else if (newStudentPatch.resolved.isPatchingFailed) {
        alert(store.getError(newStudentPatch.resolved).message);
      }
      newState.archiveStudent = false;
      actions.closeModal();
    }

    newState.listData = store.getAll(studentList, listParams);
    return newState;
  }

  componentDidMount() {
    const { actions } = this.props;
    const { page } = this.state;
    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const filterData = {
      page,
      per_page: RESULTS_PER_PAGE,
      student_type: STUDENT_TYPE.TEACHER,
    };
    actions.getStudentList(listParams, filterData);
    actions.getConfig(USER_CONFIG);
    actions.getConfig(BATCHES_CONFIG);
    actions.getPrograms();
  }

  componentDidUpdate(prevProps, prevState) {
    const { actions, studentSlots } = this.props;
    const {
      page,
      searchKey,
      listData,
      studentId,
      archiveStudent,
      filterParam,
      regionFilter,
    } = this.state;

    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const filterData = {
      page,
      per_page: RESULTS_PER_PAGE,
      student_type: STUDENT_TYPE.TEACHER,
    };

    if (studentId && archiveStudent) {
      const studentSlotsGet = store.get(studentSlots, studentId);
      if (studentSlotsGet && studentSlotsGet.isLoaded) {
        const data = studentSlotsGet.data;
        if (data && Array.isArray(data) && data.length > 0) {
          alert('Expire Student Slots first');
          this.setState({
            archiveStudent: false,
          });
        } else {
          actions.openModal(
            MODAL_FORM.CONFIRMATION,
            {
              blocking: true,
              transparent: false,
            },
            { onConfirm: this.onConfirmation },
          );
        }
      }
    }

    if (searchKey) {
      filterData.search = searchKey;
    }

    if (regionFilter) {
      filterData.region = regionFilter;
    }

    const isListStale = !!(listData && listData.isStale);

    if (
      prevState.searchKey !== searchKey ||
      prevState.page !== page ||
      filterParam !== prevState.filterParam ||
      regionFilter !== prevState.regionFilter ||
      isListStale
    ) {
      if (filterParam) {
        filterParam.forEach(filter => {
          let value = filter.value;
          const key = filter.id;

          if (value && Array.isArray(value) && value.length) {
            filterData[key] = value;
          } else {
            if (value !== null) {
              filterData[key] = value;
            }
          }
        });
      }
      actions.getStudentList(listParams, filterData);
    }
  }

  openStudentForm = ({ formType, data }) => {
    const { actions } = this.props;

    if (FORM_ACTIONS.hasOwnProperty(formType)) {
      actions.openModal(
        MODAL_FORM.STUDENT,
        {
          size: 'custom',
          width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
          height: MODAL.HEIGHT,
        },
        { formType, data },
      );
    }
  };

  openPhoneForm = ({ formType, data }) => {
    const { actions } = this.props;

    if (FORM_ACTIONS.hasOwnProperty(formType)) {
      actions.openModal(
        MODAL_FORM.PHONE,
        {
          size: 'custom',
          width: `${Math.ceil((window.innerWidth * 50) / 100)}px`,
          height: '280px',
        },
        { formType, data },
      );
    }
  };

  onPageChange = newPage => {
    this.setState({ page: newPage }, () => {});
  };

  onCreateDemo = studentId => {
    const { actions } = this.props;
    actions.openModal(
      MODAL_FORM.CREATE_DEMO_SLOT,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { formType: FORM_ACTIONS.CREATE, studentId: studentId, trainingTeachers: true },
    );
  };

  onFilter = filters => {
    this.setState({ filterParam: filters });
  };

  onRegionChange = region => {
    if (region && Array.isArray(region)) {
      let regionData = region.map(data => data.value);
      this.setState({ regionFilter: [...regionData] });
    } else {
      this.setState({ regionFilter: null });
    }
  };

  onConfirmation = value => {
    if (value === MODAL_CONFIRMATION_ACTIONS.CONFIRMED) {
      const { actions } = this.props;
      const {
        studentId,
        studentPatch: { id },
      } = this.state;
      const data = {
        state: 'INACT',
      };
      if (studentId) {
        actions.editStudent(id + studentId, studentId, data);
      }
    } else {
      this.setState({
        archiveStudent: false,
      });
    }
  };

  onSearch = searchKey => {
    if (searchKey !== this.state.searchKey && (this.state.searchKey || searchKey))
      this.setState({ searchKey: searchKey });
  };

  render() {
    const { page, searchKey, listData } = this.state;
    const { userConfig } = this.props;
    let regionOptions = [];

    if (userConfig && userConfig.isLoaded) {
      regionOptions = getOptions({ field: 'region', userConfig: userConfig.data });
    }

    return (
      <FullFlexView justifyContent="center" alignItems="center">
        <Head>
          <Button
            label="Create Student +"
            disabled={false}
            onClick={() => this.openPhoneForm({ formType: FORM_ACTIONS.CREATE })}
          />
          <Search onSearch={this.onSearch} placeholder="Search Students..." />
        </Head>
        <FilterWrapper>
          <Field key="region">
            <Label>{'Region Filter'}</Label>
            <SelectInput
              name="region"
              onChange={this.onRegionChange}
              options={regionOptions}
              isMulti={true}
            />
          </Field>
        </FilterWrapper>
        <StudentList
          students={!!listData ? listData.data : []}
          searchKey={searchKey}
          openStudentForm={this.openStudentForm}
          onCreateDemo={this.onCreateDemo}
          onFilter={this.onFilter}
        />
        <Separator transparent height="25" />
        <Pagination
          page={page}
          perPage={RESULTS_PER_PAGE}
          count={null}
          onPageChange={this.onPageChange}
        />
      </FullFlexView>
    );
  }
}

export default withRouter(
  connect(
    ({ studentList, studentSlots, students, configs }) => ({
      studentList,
      studentSlots,
      students,
      userConfig: store.get(configs, USER_CONFIG),
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getStudentList,
          getConfig,
          getPrograms,
          openModal,
          invalidateStudentList,
          editStudent,
          closeModal,
        },
        dispatch,
      ),
    }),
  )(TrainingAccounts),
);
